var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TooltipIconButton',_vm._g({attrs:{"icon":_vm.icon,"tooltipText":"tooltip.details","color":_vm.color,"disabled":_vm.disabled}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }